import { render, staticRenderFns } from "./_avatar.vue?vue&type=template&id=1ba3dad2"
import script from "./_avatar.vue?vue&type=script&lang=js"
export * from "./_avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports